import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from 'react';
import heartBlue from '../../../../assets/svg/heart_blue.svg';
import heartGreen from '../../../../assets/svg/heart_green.svg';
import heartPink from '../../../../assets/svg/heart_pink.svg';
import './LikeAnimation.scss';
import { LiveState } from '../../LiveContainer';
import { convertRtmMessage } from '../../models/liveComment';
import { MessageType } from '../../types/messageType';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../store/store';

const HEART_ICONS = [heartBlue, heartGreen, heartPink];
const ANIMATION_TIME = 2500;
const MAX_CONCURRENT_HEART = 20;

export type LikeAnimationRef = {
  createHeart: (anchor?: string | undefined) => void;
};

type Props = {
  liveState: LiveState;
};

function LikeAnimation(props: Props, ref: any) {
  const heartIconIndex = useRef(0);
  const [isInit, setIsInit] = useState(false);
  const concurrentCount = useRef(0);

  const liveState = useSelector((state: AppState) => state.live);

  useEffect(() => {
    if (isInit) {
      return;
    }
    const userData = props.liveState.userData;

    if (
      !props.liveState.isInLive ||
      props.liveState.liveData === undefined ||
      userData === undefined
    ) {
      return;
    }

    props.liveState.rtmEngine?.on('ChannelMessage', (message: any): void => {
      const liveMessage = convertRtmMessage(JSON.stringify(message));
      if (liveMessage.commentConfig === MessageType.SEND_NICE) {
        if (
          userData?.id !== liveMessage.commentUser?.id &&
          !liveMessage.comment
        ) {
          createHeartAnimation();
        }
      }
    });

    setIsInit(true);
  }, [props.liveState.isInLive]);

  useImperativeHandle(ref, () => {
    return {
      createHeart: createHeartAnimation,
    };
  });

  const createHeartAnimation = (anchor?: string | undefined) => {
    if (concurrentCount.current >= MAX_CONCURRENT_HEART) {
      return;
    }
    let likeBoxEl = document.querySelector(
      anchor || '.live-media-player__likebox',
    );
    if (!likeBoxEl) {
      likeBoxEl = document.querySelector(
        '#live-reaction-animation',
      ) as HTMLDivElement;
    }
    const randomAnimate = Math.floor(Math.random() * 5) + 1;
    const newIcon = document.createElement('img');
    const div = document.createElement('div');
    div.classList.add('live-media-player__heart__animation');
    newIcon.classList.add(`heart__animation-${randomAnimate}`);

    heartIconIndex.current =
      heartIconIndex.current === 2 ? 0 : heartIconIndex.current + 1;
    newIcon.src = HEART_ICONS[heartIconIndex.current];
    div.appendChild(newIcon);
    likeBoxEl.appendChild(div);
    concurrentCount.current++;

    setTimeout(() => {
      div.remove();
      concurrentCount.current--;
    }, ANIMATION_TIME - 100);
  };

  return (
    <div
      id="live-reaction-animation"
      className={liveState.isLive ? '' : 'live-reaction-animation__voice'}
    ></div>
  );
}

export default forwardRef(LikeAnimation);
